import { apiClient } from '@/shared/services/http/http.service'
import { SURVEY_ENDPOINTS } from '../constants/endpoints.constant.js'

const FILENAME_REGEX = /filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/i

function parseFilename(contentDisposition, fallback) {
  if (!contentDisposition)
    return fallback
  const match = FILENAME_REGEX.exec(contentDisposition)
  if (!match?.[1])
    return fallback
  try {
    return decodeURIComponent(match[1])
  }
  catch {
    return match[1]
  }
}

export async function exportResponses(surveyId) {
  const url = SURVEY_ENDPOINTS.EXPORT.replace(':id', surveyId)
  const response = await apiClient('generic-survey').get(url, { responseType: 'blob' })

  if (response.status < 200 || response.status >= 300) {
    throw new Error(`Export failed with status ${response.status}`)
  }

  const contentType = response.headers?.['content-type'] ?? ''
  if (contentType.includes('application/json')) {
    throw new Error('Export failed')
  }

  const blob = response.data instanceof Blob
    ? response.data
    : new Blob([response.data], { type: 'text/csv;charset=utf-8;' })

  const filename = parseFilename(
    response.headers?.['content-disposition'],
    `survey-${surveyId}-responses.csv`,
  )

  return { blob, filename }
}
